import {useSubheader} from "../../../_metronic/layout";
import React, {useEffect, useRef, useState} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import makeRequest from "../../api/makeRequest";
import {useAlert} from "react-alert";
import {useTranslation} from "react-i18next";


const defInitialValues = {
	name: "",
	username: "",
	password: "",
};

export const EditUserPage = ({match}) => {
	const { t } = useTranslation('common');
	const {id: ID} = match.params
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('EditUser'));

	let initialValues = useRef(defInitialValues)

	const [loading, setLoading] = useState(false);
	const [okMessage, setOkMessage] = useState('');
	const LoginSchema = Yup.object().shape({
		name: Yup.string()
			.required(
				t('PleaseName')
			),
		username: Yup.string()
			.min(3, t('AtLeastCharacters'))
			.required(
				t('PleaseUserName')
			),
		password: Yup.string()
			.min(3, t('AtLeastCharacters'))
	});

	const alert = useAlert()

	useEffect(() => {
		enableLoading();
		makeRequest('getUser', {
			"id": ID,
		}).then(({data}) => {
			if (data.success) {
				initialValues.current = {
					...data.user,
					password: ''
				}
			} else {
				const {error} = data
				alert.error(error)
			}
		}).catch(() => {
			alert.error(t('Error'))
		})
			.finally(() => {
				disableLoading();
			})
	}, [])

	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};

	const getInputClasses = (fieldname) => {
		if (formik.touched[fieldname] && formik.errors[fieldname]) {
			return "is-invalid";
		}

		if (formik.touched[fieldname] && !formik.errors[fieldname]) {
			return "is-valid";
		}

		return "";
	};

	let history = useHistory();

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: initialValues.current,
		validationSchema: LoginSchema,
		onSubmit: async (values, {setStatus, setSubmitting}) => {
			enableLoading();
			const params = {
				"id": ID,
				"name": values.name,
				"username": values.username,
			}
			if (values.password) params.password = values.password
			makeRequest('editUser', params).then(({data}) => {
				const {success} = data
				if (success) {
					setOkMessage(t('UserBuiltEdit'))
					setTimeout(() => {
						history.push('/user')
					}, 1000)
				} else {
					const {error} = data
					setSubmitting(false);
					setStatus(error)
				}
			}).catch(() => {
				setSubmitting(false);
				setStatus(t('Error'))
			}).finally(() => {
				disableLoading();
			})
		},
	});

	return (
		<>
			<form
				onSubmit={formik.handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
			>
				{formik.status ? (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{formik.status}</div>
					</div>
				) : null}
				{okMessage ? (
					<div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
						<div className="alert-text font-weight-bold">{okMessage}</div>
					</div>
				) : null}

				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.FULLNAME')}
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"name"
						)}`}
						name="name"
						{...formik.getFieldProps("name")}
					/>
					{formik.touched.name && formik.errors.name ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.name}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.USERNAME')}
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"username"
						)}`}
						name="username"
						{...formik.getFieldProps("username")}
					/>
					{formik.touched.username && formik.errors.username ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.username}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.PASSWORD')}
						type="password"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"password"
						)}`}
						name="password"
						{...formik.getFieldProps("password")}
					/>
					{formik.touched.password && formik.errors.password ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.password}</div>
						</div>
					) : null}
				</div>
				<div className="form-group d-flex flex-wrap justify-content-between align-items-center">
					<button
						id="kt_login_signin_submit"
						type="submit"
						disabled={formik.isSubmitting}
						className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
					>
						<span>{t('Edit')}</span>
						{loading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
					</button>
				</div>
			</form>
		</>
	)
}
